import { SopEditorPage } from '@/pages/sops/SopEditorPage'
import PageLoading from '@/components/PageLoading'
import { createFileRoute, useRouterState } from '@tanstack/react-router'

function SopEditorPending() {
  const shouldSkip = useRouterState({
    select: (state) => {
      const locationState = (state.location.state || {}) as {
        fromGenerating?: boolean
      }
      if (locationState.fromGenerating) return true

      // Fallback: read browser history state shape used by some navigation flows.
      if (typeof window === 'undefined') return false
      const historyState = (window.history.state || {}) as {
        fromGenerating?: boolean
        usr?: { fromGenerating?: boolean }
        state?: { fromGenerating?: boolean }
      }
      return !!(
        historyState.fromGenerating ||
        historyState.usr?.fromGenerating ||
        historyState.state?.fromGenerating
      )
    },
  })

  if (shouldSkip) {
    return null
  }

  return (
    <div>
      <PageLoading />
    </div>
  )
}



export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/sops/$sopId/'
)({
  component: SopEditorPage,
  pendingComponent: SopEditorPending,
  pendingMs: 0,
  pendingMinMs: 100,
})
